export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-pencil-f6502a4b812bd7a2baca6937081a3b5d.svg";